import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import {HttpModule} from '@angular/http';

import {AppComponent} from './app.component';
import {NAV_DROPDOWN_DIRECTIVES} from './shared/nav-dropdown.directive';

import {ChartsModule} from 'ng2-charts/ng2-charts';
import {SIDEBAR_TOGGLE_DIRECTIVES} from './shared/sidebar.directive';
import {AsideToggleDirective} from './shared/aside.directive';
import {BreadcrumbsComponent} from './shared/breadcrumb.component';
import {SmartResizeDirective} from './shared/smart-resize.directive';

// Routing Module
import {AppRoutingModule} from './app.routing';

// Layouts
import {FullLayoutComponent} from './layouts/full-layout.component';
import {SimpleLayoutComponent} from './layouts/simple-layout.component';
import {P404Component} from './pages/404.component';

// Shared
import {AuthGuard} from './model/auth.guard';
import {SharedModule} from './shared/shared.module';

// Model & Services
import {GlobalService} from './model/global.service';
import {StaffService} from './model/staff.service';
import {StaffDataService} from './model/staff-data.service';
import {UserDataService} from './model/user-data.service';
import {CampaignDataService} from "./model/campaign-data.service";
import {DashboardDataService} from "./model/dashboard-data.service";
import {ReportDataService} from "./model/report-data.service";
// import {AuditorDataService} from "./model/auditor-data.service";

@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        ChartsModule,
        HttpModule,
        SharedModule,
    ],
    declarations: [
        AppComponent,
        FullLayoutComponent,
        SimpleLayoutComponent,
        NAV_DROPDOWN_DIRECTIVES,
        BreadcrumbsComponent,
        SIDEBAR_TOGGLE_DIRECTIVES,
        AsideToggleDirective,
        SmartResizeDirective,
        P404Component,
    ],
    providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        AuthGuard,
        StaffService,
        GlobalService,
        StaffDataService,
        UserDataService,
        CampaignDataService,
        DashboardDataService,
        ReportDataService,
        // AuditorDataService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/sujay/crpanel/crpanel/backend/backend/src/app/app.module.ts